import React, { lazy } from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    id: 1,
    quote: 'Llevaba un año buscando algo para complementar mi sueldo de administrativa. En mi primer mes con el método facturé 180€ con 3 videos. A los 4 meses llegué a 620€ mensuales trabajando 8 horas a la semana fuera de mi horario laboral.',
    name: 'Laura M.',
    age: '28 años',
    city: 'Madrid',
    job: 'Administrativa',
    img: 'https://i.pravatar.cc/150?img=47'
  }, {
    id: 2,
    quote: 'Trabajo en hostelería con turnos rotatorios. Empecé con videos de unboxing de productos tech. Mi primer video para una marca de auriculares me pagó 80€. Hoy facturo entre 400€ y 700€ mensuales según la carga que quiero asumir.',
    name: 'Marcos R.',
    age: '34 años',
    city: 'Valencia',
    job: 'Hostelería',
    img: 'https://i.pravatar.cc/150?img=11'
  }, {
    id: 3,
    quote: 'Soy madre de dos hijos con jornada parcial. Tenía mucho miedo a aparecer en cámara. Empecé con videos donde solo se veían mis manos. En 6 meses construí portfolio con 15 marcas y ahora facturo entre 300€ y 500€ mensuales con total flexibilidad.',
    name: 'Elena P.',
    age: '41 años',
    city: 'Barcelona',
    job: 'Comercio',
    img: 'https://i.pravatar.cc/150?img=44'
  }];
  return <section className="bg-white py-20 px-4" data-id="element-397">
      <div className="max-w-5xl mx-auto" data-id="element-398">
        <div className="text-center mb-10" data-id="element-399">
          <span className="text-neon font-bold text-sm tracking-widest uppercase bg-black px-4 py-1 rounded-full" data-id="element-400">
            — RESULTADOS REALES —
          </span>
        </div>

        <h2 className="text-3xl md:text-5xl font-extrabold text-black text-center leading-tight mb-16 font-montserrat" data-id="element-401">
          "Personas Normales en España Están Usando Este Sistema Ahora Mismo"
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-402">
          {testimonials.map(t => <div key={t.id} className="bg-gray-900 rounded-2xl border-2 border-neon p-8 shadow-neon relative flex flex-col h-full" data-id="element-403">
              <div className="flex justify-center mb-6" data-id="element-404">
                <div className="flex gap-1" data-id="element-405">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" data-id="element-406" />)}
                </div>
              </div>

              <blockquote className="text-gray-300 italic text-lg mb-8 flex-grow text-center" data-id="element-407">
                "{t.quote}"
              </blockquote>

              <div className="flex items-center gap-4 border-t border-gray-800 pt-6 mt-auto" data-id="element-408">
                <img src={t.img} alt={t.name} width={64} height={64} loading="lazy" decoding="async" className="w-16 h-16 rounded-full border-2 border-neon object-cover" data-id="element-409" />
                <div data-id="element-410">
                  <p className="font-bold text-white text-lg" data-id="element-411">{t.name}</p>
                  <p className="text-neon text-sm" data-id="element-412">
                    {t.age} · {t.city}
                  </p>
                  <p className="text-gray-400 text-xs uppercase tracking-wider mt-1" data-id="element-413">
                    {t.job}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}